<script lang="ts">
  import Placeholder from "@component/Placeholder.svelte";
  let { route } = $props();
</script>

<Placeholder name="header" {route} />
<main id="main">
  <Placeholder name="main" {route} />
</main>
<Placeholder name="footer" {route} />
